/* Only loaded by the Wellness layout. No cart, checkout or Sports-page changes. */
(() => {
  function enhanceDemo() {
    const panel = document.getElementById('kuew-demo');
    if (!panel || panel.closest('dialog') || !window.HTMLDialogElement) return;
    const dialog = document.createElement('dialog');
    dialog.className = 'kuew-dialog';
    dialog.setAttribute('aria-labelledby', 'kuew-demo-title');
    document.body.append(dialog);
    dialog.append(panel);
    let trigger;
    function open(from) {
      trigger = from || document.activeElement;
      if (!dialog.open) dialog.showModal();
    }
    document.addEventListener('click', event => {
      const link = event.target.closest('[data-kuew-demo]');
      if (link) { event.preventDefault(); open(link); }
    });
    panel.querySelector('[data-kuew-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => trigger?.focus());
    if (panel.querySelector('[data-kuew-result]') || location.hash === '#kuew-demo') open();
  }
  function enhanceSliders() {
    document.querySelectorAll('[data-kuew-slider]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const track = root.querySelector('.kuew-review-track');
      const prev = root.querySelector('[data-kuew-prev]');
      const next = root.querySelector('[data-kuew-next]');
      if (!track || !prev || !next) return;
      const update = () => {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      const slide = direction => {
        const card = track.firstElementChild;
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      prev.addEventListener('click', () => slide(-1));
      next.addEventListener('click', () => slide(1));
      track.addEventListener('scroll', update, {passive: true});
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); slide(event.key === 'ArrowRight' ? 1 : -1);
      });
      if (window.ResizeObserver) new ResizeObserver(update).observe(track);
      else window.addEventListener('resize', update);
      update();
    });
  }
  enhanceDemo(); enhanceSliders();
  document.addEventListener('shopify:section:load', enhanceSliders);
})();




/* =========================================
   ACTICOMPRESS DEMO FORM
   Submit without leaving current page
========================================= */

document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('KueWellnessDemo');
  const frame = document.getElementById('KueWellnessDemoTarget');

  if (!form || !frame) return;

  form.setAttribute('target', 'KueWellnessDemoTarget');

  let submitted = false;

  form.addEventListener('submit', function () {
    if (!form.checkValidity()) return;

    submitted = true;

    const button = form.querySelector('button[type="submit"]');
    const success = form.querySelector('[data-kuew-demo-success]');
    const error = form.querySelector('[data-kuew-demo-error]');

    if (success) success.hidden = true;
    if (error) error.hidden = true;

    if (button) {
      button.dataset.originalHtml = button.innerHTML;
      button.disabled = true;
      button.textContent = 'Sending...';
    }
  });

  frame.addEventListener('load', function () {
    if (!submitted) return;

    submitted = false;

    const button = form.querySelector('button[type="submit"]');
    const success = form.querySelector('[data-kuew-demo-success]');
    const error = form.querySelector('[data-kuew-demo-error]');

    if (button) {
      button.disabled = false;

      if (button.dataset.originalHtml) {
        button.innerHTML = button.dataset.originalHtml;
      }
    }

    if (success) {
      success.hidden = false;
    }

    if (error) {
      error.hidden = true;
    }

    form.reset();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const demoDate = document.getElementById('KueDemoDate');

  if (demoDate) {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');

    demoDate.min = `${yyyy}-${mm}-${dd}`;
  }
});